import React from "react";
import { TabsContent } from "components/ui/tabs";
import { cn } from "utils";

interface ManuscriptDetailsTabBoxProps {
  value: string;
  children: React.ReactNode;
  className?: string;
}

export const ManuscriptDetailsTabBox: React.FC<
  ManuscriptDetailsTabBoxProps
> = ({ value, children, className }) => {
  return (
    <TabsContent value={value} className={cn("flex-none", className)}>
      {children}
    </TabsContent>
  );
};
